import React from "react";
import "./MainActionButton.css"; // Import its own CSS

function MainActionButton({ onClick, className, children, title }) {
  return (
    <button
      className={`main-action-button ${className || ""}`}
      onClick={onClick}
      title={title}
    >
      {children}
    </button>
  );
}

export default MainActionButton;
